module.exports = __webpack_public_path__ + "static/media/banner1.a32e5387.jpg";